import { render, staticRenderFns } from "./Merchantlist.vue?vue&type=template&id=491495be&scoped=true&"
import script from "./Merchantlist.vue?vue&type=script&lang=js&"
export * from "./Merchantlist.vue?vue&type=script&lang=js&"
import style0 from "./Merchantlist.vue?vue&type=style&index=0&id=491495be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491495be",
  null
  
)

export default component.exports